import React from 'react'
import SectionTitle from '../components/section-title'
import { InlineLinkDarkControl as InlineLink } from './inline-link-control'

interface IProps {
  parcelsSelected: string[]
  parcelData: any
  parcelAggregates: any
  areaData: any
}

const SalvageTranslocation = class extends React.Component<IProps> {
  renderSalvageTranslocationText() {
    const { parcelsSelected, parcelAggregates, areaData } = this.props
    if (
      (parcelsSelected.length && parcelAggregates.anyIntSalvageAndTranslocationArea === false) ||
      (areaData && areaData.intSalvageAndTranslocationArea === false)
    ) {
      return (
        <p>
          The selected {parcelsSelected.length ? 'parcel(s) are' : 'area is'} not labelled as ‘Potential Salvage
          Operations’ and salvage is therefore not required.
        </p>
      )
    } else {
      return (
        <>
          <p>
            Your {parcelsSelected.length ? 'parcel(s) are' : 'area is'} labelled as ‘Potential Salvage Operations’ and
            salvage may be required to assist with restoration programs under the Melbourne Strategic Assessment (MSA)
            program.
          </p>

          <p>
          Our team will arrange to do this at no cost to the landowner, we just require access to the land.
          </p>
          
          <p>
            Please submit a completed{' '}
            <InlineLink href="https://mapshare.vic.gov.au/msa/pdfs/salvage-enquiry-form-(editable).pdf" /> to{' '}
            <InlineLink href="mailto:msa.conservation@delwp.vic.gov.au" text="msa.conservation@delwp.vic.gov.au" />.
          </p>
        </>
      )
    }
  }

  render() {
    return (
      <>
        <SectionTitle title="Salvage and translocation"></SectionTitle>
        {this.renderSalvageTranslocationText()}
      </>
    )
  }
}

export default SalvageTranslocation
